export const studyService = "/studyService/api"
export const operateService = "/operateService/api"
export const tradeService = "/tradeService/api"
export const userService = "/userService/api"
export const workstationService = "/workstationService/api"
export const logTrackService = "/logTrackService/api"
export const healthyService = "/coreService/api"
